import React from "react";
import Image from "next/image";

// components
import Link from "@/components/Link";

// interfaces
import { TreadingLocationSlideProps } from "./ITreadingLocationSlide";

// assets
import styles from "@/assets/styles/pages/lolive/trending-locations-slide.module.scss";

const TreadingLocationSlide = ({ slug, pictureUrl, city, name }: TreadingLocationSlideProps) => (
  <Link
    className={styles["locl-trending-locations-slide"]}
    href={`/location/${slug}`}
    data-testid="locl-trending-locations-slide"
  >
    <div className={styles["locl-trending-locations-slide__image"]}>
      <Image src={pictureUrl} alt={name} fill loading="lazy" sizes="300px" className={styles["locl-trending-locations-slide__image-content"]} />
    </div>
    <div className={styles["locl-trending-locations-slide__info"]}>
      <span className={styles["locl-trending-locations-slide__city"]}>{city.name}</span>
      <h4 className={styles["locl-trending-locations-slide__name"]}>{name}</h4>
    </div>
  </Link>
);

export default TreadingLocationSlide;
